// @flow

import type {
  ApplicationChargeState,
  ApplicationChargeAction
} from 'stores/flow-type/subscriptions.type';

import {
  ACTIVATE_APPLICATION_CHARGE_REQUEST,
  ACTIVATE_APPLICATION_CHARGE_SUCCESS,
  ACTIVATE_APPLICATION_CHARGE_FAILURE
} from 'stores/flow-type/application-charge.type';

const initialState: ApplicationChargeState = {
  activating: false,
  success: false,
  error: undefined
};

const applicationChargeReducers = (
  state: ApplicationChargeState = initialState,
  action: ApplicationChargeAction
) => {
  switch (action.type) {
    // Activate charge
    case ACTIVATE_APPLICATION_CHARGE_REQUEST:
      return { ...state, activating: true, success: false };
    case ACTIVATE_APPLICATION_CHARGE_SUCCESS: {
      const { data } = action.payload;

      const { message } = data;

      if (message === 'active') {
        return { ...state, activating: false, error: undefined, success: true };
      }

      return { ...state, activating: false, error: undefined, success: false };
    }
    case ACTIVATE_APPLICATION_CHARGE_FAILURE:
      return {
        ...state,
        activating: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default applicationChargeReducers;
